import { gql } from "lib/apolloClient";

export const courseOverviewCountFragments = {
  elementSetCoverageCount: gql`
    fragment elementSetCoverageCount on GenericYearlyInsightPlannerElementSetCoverage {
      type
      leafNodeCount
      nodesCount
      plannerElementNode {
        id
        isLeaf
        associatedParents {
          id
        }
      }
      nodes {
        id
        isLeaf
        associatedParents {
          id
        }
      }
    }
  `,
};

const focusAreaItem = gql`
  fragment focusAreaItem on FocusArea {
    id
    label
    __typename
  }
`;

const themeItem = gql`
  fragment themeItem on PlannerTheme {
    id
    label
    descriptor
    metadata
    associatedChildren {
      id
      label
      __typename
    }
    focusAreas {
      ...focusAreaItem
      __typename
    }
    iconUrl: icon
    __typename
  }
  ${focusAreaItem}
`;

const actionItem = gql`
  fragment actionItem on Action {
    id
    label
    subText
    children
    parent
    levels {
      id
      value
      __typename
    }
    levelId
    __typename
  }
`;

const lpItem = gql`
  fragment lpItem on PlannerLearnerProfile {
    id
    label
    subText
    levelId
    parent
    children
    __typename
  }
`;

const conceptItem = gql`
  fragment conceptItem on PlannerConcept {
    id
    label
    subText
    levelId
    parent
    children
    __typename
  }
`;

const relatedConceptItem = gql`
  fragment relatedConceptItem on PlannerRelatedConcept {
    id
    label
    elementId
    elementType
    parent
    children
    __typename
  }
`;

const subjectGroupBasicDetailsItem = gql`
  fragment subjectGroupBasicDetailsItem on SubjectGroup {
    id
    name
    constants
    __typename
  }
`;

const nonPypPlannerElementNodeItem = gql`
  fragment nonPypPlannerElementNodeItem on PlannerElementNode {
    id
    displaySequence
    label
    subText
    code
    type
    depth
    children
    parent
    updatedAt
    icon {
      id
      title
      url
      metadata
      __typename
    }
    dataSetNodeWrapper {
      plannerElementNodeSet {
        id
        title
        __typename
      }
      properties {
        isArchived
        grades {
          id
          name
          __typename
        }
        subjects {
          id
          name
          isArchived
          __typename
        }
        tags {
          id
          label
          __typename
        }
        subjectGroups {
          ...subjectGroupBasicDetailsItem
          __typename
        }
        associatedPlannerElementNodes {
          id
          label
          type
          metadata
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
  ${subjectGroupBasicDetailsItem}
`;

const plannerElementNodeSetWrapperV2Item = gql`
  fragment plannerElementNodeSetWrapperV2Item on PlannerElementNodeSet {
    plannerElementNodeSetWrapperV2 {
      ... on PlannerElementNodeSetWrapper {
        publishedData(filters: $plannerElementNodeFilters) {
          edges {
            node {
              ...nonPypPlannerElementNodeItem
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      ... on PlannerActionSetWrapper {
        publishedData {
          edges {
            node {
              ...actionItem
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      ... on PlannerLearnerProfileSetWrapper {
        publishedData {
          edges {
            node {
              ...lpItem
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      ... on PlannerConceptSetWrapper {
        publishedData {
          edges {
            node {
              ...conceptItem
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      ... on PlannerRelatedConceptSetWrapper {
        publishedData(filters: $plannerElementNodeFilters) {
          edges {
            node {
              ...relatedConceptItem
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      ... on PlannerThemeSetWrapper {
        publishedData(filters: { academicYear: $academicYearId }) {
          edges {
            node {
              ...themeItem
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
  ${nonPypPlannerElementNodeItem}
  ${actionItem}
  ${lpItem}
  ${conceptItem}
  ${relatedConceptItem}
  ${themeItem}
`;

export const plannerElementNodeSetFragments = {
  plannerElementNodeSetItem: gql`
    fragment plannerElementNodeSetItem on PlannerElementNodeSetConnection {
      edges {
        node {
          id
          type
          plannerElementSet {
            id
            type
            config {
              id
              config
              valueType
              value
              __typename
            }
            __typename
          }
          ...plannerElementNodeSetWrapperV2Item
          __typename
        }
        __typename
      }
      __typename
    }
    ${plannerElementNodeSetWrapperV2Item}
  `,
};
